import React from 'react';
import { useIntl } from 'react-intl';
import dynamic from 'next/dynamic';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

import { maybeFormatMessage } from 'utils/i18nUtils';

import { Section, ImageContainer } from './styles/Container';
import { StyledTypography } from './styles/Typography';

const ResponsiveImages = dynamic(import('components/ResponsiveImage/ResponsiveImages'), { ssr: false });

function SectionCustomerService() {
  const intl = useIntl();

  return (
    <Section>
      <Typography
        variant="title"
        intlKey="FGTS.CS.TITLE"
      />
      <ImageContainer>
        <ResponsiveImages
          fileName="xpeer-fgts/xpeer-fgts.jpg"
          alt={maybeFormatMessage(intl, 'FGTS.CS', 'ALT_IMAGE')}
          loading="lazy"
        />
      </ImageContainer>
      <StyledTypography
        variant="subtitle"
        intlKey="FGTS.CS.SUBTITLE"
      />
    </Section>
  );
}

export default React.memo(SectionCustomerService);
